import { render } from "./QR.vue?vue&type=template&id=15ecef36"
import script from "./QR.vue?vue&type=script&lang=js"
export * from "./QR.vue?vue&type=script&lang=js"
script.render = render

export default script